import { httpRequest } from '@calendly/http-tools'
import { I18n } from '@calendly/i18n'
import { createAsyncThunk } from '@reduxjs/toolkit'

import { updatePaymentInfo } from './update_payment_info'
import { updateStripeCard } from './update_stripe_card'

export const changeQuantity = createAsyncThunk(
  'payment/changeQuantity',
  async ({ stripe,
    elements,
    billingAddress,
    taxId,
    quantity,
    isStripeProvider,
    billingCountry,
    billingZip },
  { rejectWithValue, dispatch }
  ) => {
    if (stripe) {
      if (isStripeProvider) {
        const result = await dispatch(updatePaymentInfo({ stripe, elements, billingCountry, billingZip }))
        if (result.error) {
          return rejectWithValue({
            errorMessage: I18n.t('errors.billing.server'),
            isCardError: true
          })
        }
      } else {
        const { success, errorMessage } = await dispatch(updateStripeCard({ stripe, elements, billingAddress, taxId }))
        if (!success) {
          return rejectWithValue({
            errorMessage,
            isCardError: true
          })
        }
      }
    }

    const [success, response] = await httpRequest({
      url: '/api/billing/subscription/quantity',
      method: 'PUT',
      params: {
        quantity
      }
    })

    if (!success) {
      // Handle both response structures: response.error.payload (new) or response.payload (old)
      const errorPayload = response.error?.payload || response.payload
      const errorCode = errorPayload?.api_error_code
      const httpStatusCode = errorPayload?.http_status_code || response.status || response.error?.payload?.http_status_code
      let errorMessage = errorPayload?.message || response.message

      // Use generic server error message for 5xx errors or generic HTTP error messages
      const isServerError = httpStatusCode >= 500 && httpStatusCode < 600
      const patterns = [
        'Error response not in JSON format',
        'SERVER ERROR',
        'http status code'
      ]
      const isGenericError = errorMessage && patterns.some((pattern) => errorMessage.includes(pattern))

      if ((isServerError || isGenericError) && (!errorMessage || isGenericError)) {
        errorMessage = I18n.t('errors.billing.server')
      }

      return rejectWithValue({
        errorMessage,
        isCardError: errorCode === 'payment_processing_failed'
      })
    }

    return response
  }
)
